import { render, staticRenderFns } from "./LlQuizQuestionEditList.vue?vue&type=template&id=3a56b257"
import script from "./LlQuizQuestionEditList.vue?vue&type=script&lang=js"
export * from "./LlQuizQuestionEditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports